import type { Rive, StateMachineInput } from "@rive-app/react-canvas";
import React from "react";

/**
 * Rewriting of useStateMachineInput from react-rive library to support multiple inputs.
 */
export const useMultipleStateMachineInputs = (
  rive: Rive | null,
  stateMachineName?: string,
  inputNames?: string[],
): ((inputName: string) => StateMachineInput | undefined) => {
  const [inputMap, setInputMap] = React.useState<Map<
    string,
    StateMachineInput
  > | null>(null);

  React.useEffect(() => {
    if (rive && stateMachineName && inputNames) {
      const inputs = rive.stateMachineInputs(stateMachineName);
      if (inputs) {
        // creating a new map instead of mutating existing map to keep the inputMap state immutable.
        const newMap = new Map<string, StateMachineInput>();

        inputs.forEach(input => {
          if (inputNames.includes(input.name)) {
            newMap.set(input.name, input);
          }
        });
        setInputMap(newMap);
      }
    } else {
      setInputMap(null);
    }
  }, [inputNames, rive, stateMachineName]);

  const getInputFromName = (inputName: string) => inputMap?.get(inputName);

  return getInputFromName;
};
